import { QueryEntity } from "@datorama/akita";
import { BehaviorSubject } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { singleton } from "tsyringe";

import InstagramStoryEntity from "../entities/InstagramStoryEntity";
import InstagramStoriesStore, {
    InstagramStoriesState,
} from "../stores/InstagramStoriesStore";

@singleton()
class InstagramStoriesQuery extends QueryEntity<InstagramStoriesState> {
    active$: BehaviorSubject<InstagramStoryEntity | undefined>;
    constructor(protected store: InstagramStoriesStore) {
        super(store);
        this.active$ = new BehaviorSubject<InstagramStoryEntity | undefined>(
            undefined
        );
        this.selectActive()
            .pipe(distinctUntilChanged())
            .subscribe(this.active$);
    }
    all$ = this.selectAll();
    first$ = this.selectFirst();
    loading$ = this.selectLoading();
    error$ = this.selectError();
}

export default InstagramStoriesQuery;
